import * as React from 'react'

import toast from 'lib/toast'
import agent from 'agent'
import { messageFromResponseError } from 'utils/strings'
import TextButton from 'components/common/TextButton'

const ReinstateApiKeyButton: React.FC<{
  disabled: boolean
  identifier: string
  fetchApiKeys: () => void
}> = ({ disabled, identifier, fetchApiKeys }) => {
  return (
    <TextButton
      primary
      data-api-key-action-reinstate={identifier}
      disabled={disabled}
      onClick={async () => {
        try {
          await agent({
            method: 'PUT',
            url: `/apikeys/${encodeURIComponent(identifier)}/activate`
          })

          fetchApiKeys()
          toast({
            type: 'success',
            text: `Reinstated '${identifier}' API Key`
          })
        } catch (err) {
          toast({
            type: 'error',
            text: messageFromResponseError(
              err,
              `There was an issue reinstating '${identifier}' API Key. Please try again later.`
            )
          })
        }
      }}
    >
      {disabled
        ? 'API key limit has been reached.  Please revoke an active key.'
        : 'Reinstate Key'}
    </TextButton>
  )
}

export default ReinstateApiKeyButton
